// extracted by mini-css-extract-plugin
export default {"disclaimer":"disclaimer_disclaimer__OWwB0","disclaimer_warning":"disclaimer_disclaimer_warning__3kHt0"};